"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ValueObject_1 = require("../../Common/ValueObject");
class ChatUser extends ValueObject_1.ValueObject {
    constructor(id, name) {
        super();
        this.id = id;
        this.name = name;
    }
    *GetEqualityComponents() {
        yield* [this.id, this.name];
    }
}
ChatUser.Nobody = new ChatUser("", "");
exports.ChatUser = ChatUser;
//# sourceMappingURL=ChatUser.js.map